module.exports = __webpack_public_path__ + "img/mobile-reg-hse2.c4b820d3.png";